/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cos.index.chirp.client.CosIndexChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getParentsByIdRpc = {
  serviceName: 'com.hubspot.cos.index.chirp.client.CosIndexChirpService',
  rpcName: 'getParentsById',
  auth: 'app',
  fingerprint: '0mNlxo-nQsenhkfHNeCwj5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getParentsByIdsRpc = {
  serviceName: 'com.hubspot.cos.index.chirp.client.CosIndexChirpService',
  rpcName: 'getParentsByIds',
  auth: 'app',
  fingerprint: 'pkX7XP6vBSawSdtMbpLpmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getParentsCountRpc = {
  serviceName: 'com.hubspot.cos.index.chirp.client.CosIndexChirpService',
  rpcName: 'getParentsCount',
  auth: 'app',
  fingerprint: '__Od6sb3FXBz0j36F8uv0pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAccessGroupMembershipRpc = {
  serviceName: 'com.hubspot.cos.index.chirp.client.CosIndexChirpService',
  rpcName: 'getAccessGroupMembership',
  auth: 'app',
  fingerprint: 'pm04_Kh6ta9LgVcm4T_eppwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getChildrenRpc = {
  serviceName: 'com.hubspot.cos.index.chirp.client.CosIndexChirpService',
  rpcName: 'getChildren',
  auth: 'app',
  fingerprint: 'oLqYd4xKOimnhkfHNeCwj5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getChildIdsByParentCountsRpc = {
  serviceName: 'com.hubspot.cos.index.chirp.client.CosIndexChirpService',
  rpcName: 'getChildIdsByParentCounts',
  auth: 'app',
  fingerprint: '5VZUVM3XRBXHdHt5fBh7q5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConnectionsByTypesRpc = {
  serviceName: 'com.hubspot.cos.index.chirp.client.CosIndexChirpService',
  rpcName: 'getConnectionsByTypes',
  auth: 'app',
  fingerprint: 'PFtuaZ5pr1YEAHNhurnRrJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDependenciesRpc = {
  serviceName: 'com.hubspot.cos.index.chirp.client.CosIndexChirpService',
  rpcName: 'getDependencies',
  auth: 'app',
  fingerprint: 'eM_RrFnWrcDbYrOdt-UfeZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};